<script>
import { h } from "vue";

/**
 * The Inventory workspace's line icons (24 × 24, round caps, stroke = currentColor), in place of the emoji the pages
 * used. Each entry is a list of SVG shapes: [tag, attributes]. Sizes follow the font size unless `size` is given.
 */
const P = (d) => ["path", { d }];
const C = (cx, cy, r) => ["circle", { cx, cy, r }];
const R = (x, y, width, height, rx = 2) => ["rect", { x, y, width, height, rx }];

const ICONS = {
  // Kubi's sections
  overview: [R(3, 3, 8, 8), R(13, 3, 8, 5), R(13, 10, 8, 11), R(3, 13, 8, 8)],
  boxes: [P("M3 9l4-2 4 2v5l-4 2-4-2z"), P("M13 9l4-2 4 2v5l-4 2-4-2z"), P("M8 15l4-2 4 2v5l-4 2-4-2z")],
  recipes: [P("M6 13a4 4 0 0 1 .5-8 5 5 0 0 1 11 0 4 4 0 0 1 .5 8"), P("M6 13v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-6"), P("M6 16h12")],
  cart: [C(9, 20, 1.5), C(18, 20, 1.5), P("M2 3h3l2.6 12.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 7H6")],
  coins: [["ellipse", { cx: 9, cy: 7, rx: 6, ry: 3 }], P("M3 7v4c0 1.7 2.7 3 6 3s6-1.3 6-3V7"), P("M3 11v4c0 1.7 2.7 3 6 3 1.2 0 2.3-.2 3.2-.5"), C(17, 15.5, 4.5), P("M17 13.5v4")],
  shield: [P("M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"), P("M9 12l2 2 4-4")],

  // pages
  health: [P("M20.8 8.6a5 5 0 0 0-8.8-3.2 5 5 0 0 0-8.8 3.2c0 5.4 8.8 11.4 8.8 11.4s8.8-6 8.8-11.4z"), P("M3.5 12h4l2-3 3 6 2-3h6")],
  bell: [P("M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"), P("M10.3 21a1.9 1.9 0 0 0 3.4 0")],
  report: [P("M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"), P("M14 3v6h6"), P("M8 17v-3"), P("M12 17v-6"), P("M16 17v-2")],
  list: [P("M9 6h12"), P("M9 12h12"), P("M9 18h12"), C(4.5, 6, 1), C(4.5, 12, 1), C(4.5, 18, 1)],
  pizza: [P("M12 21L3.5 5.5a14 14 0 0 1 17 0z"), P("M5.2 8.6a11 11 0 0 1 13.6 0"), C(10, 11, 1), C(14, 12, 1), C(12, 16, 1)],
  clipboard: [R(5, 4, 14, 17), P("M9 4V3h6v1"), P("M9 11l2 2 4-4"), P("M9 17h6")],
  scale: [P("M12 3v18"), P("M7 21h10"), P("M5 7h14"), P("M5 7l-3 7a3 3 0 0 0 6 0z"), P("M19 7l-3 7a3 3 0 0 0 6 0z")],
  trash: [P("M4 7h16"), P("M10 11v6"), P("M14 11v6"), P("M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"), P("M9 7V4h6v3")],
  swap: [P("M4 8h14l-3-3"), P("M20 16H6l3 3")],
  bowl: [P("M3 11h18a9 9 0 0 1-18 0z"), P("M8 7c0-1.5 1-2 1-3.5"), P("M12 7c0-1.5 1-2 1-3.5"), P("M16 7c0-1.5 1-2 1-3.5")],
  dough: [P("M4 15a8 6 0 0 1 16 0c0 2.2-3.6 4-8 4s-8-1.8-8-4z"), P("M8 13c1.5-1.5 3-1.5 4 0s2.5 1.5 4 0")],
  layers: [P("M12 3l9 5-9 5-9-5z"), P("M3 13l9 5 9-5"), P("M3 17.5l9 5 9-5")],
  package: [P("M21 8l-9-5-9 5v8l9 5 9-5z"), P("M3 8l9 5 9-5"), P("M12 13v8"), P("M7.5 5.5l9 5")],
  quadrant: [R(3, 3, 18, 18, 3), P("M12 3v18"), P("M3 12h18"), C(7.5, 7.5, 1.3), C(16.5, 16.5, 1.3), C(16.5, 7.5, 1.3)],
  "file-pen": [P("M13 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5"), P("M13 3v6h6v2"), P("M18.4 13.6a1.9 1.9 0 0 1 2.7 2.7L16 21.4 13 22l.6-3z")],
  truck: [P("M1 4h13v12H1z"), P("M14 9h4l4 4v3h-8"), C(5.5, 18.5, 2), C(17.5, 18.5, 2)],
  receipt: [P("M5 3h14v18l-3-2-2 2-2-2-2 2-2-2-3 2z"), P("M9 8h6"), P("M9 12h6"), P("M9 16h3")],
  trend: [P("M3 17l6-6 4 4 8-8"), P("M15 7h6v6")],
  store: [P("M3 9l1.5-5h15L21 9"), P("M4 9v11h16V9"), P("M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0"), P("M10 20v-5h4v5")],
  users: [C(9, 8, 3.5), P("M2.5 20a6.5 6.5 0 0 1 13 0"), P("M16 4.5a3.5 3.5 0 0 1 0 7"), P("M18.5 14a6.5 6.5 0 0 1 3 6")],
  upload: [P("M12 15V3"), P("M7 8l5-5 5 5"), P("M4 15v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4")],
  history: [P("M3 12a9 9 0 1 0 3-6.7L3 8"), P("M3 3v5h5"), P("M12 7v5l3 2")],
  gauge: [P("M4 18a9 9 0 1 1 16 0"), P("M12 13l4-4"), C(12, 14, 1.5)],

  // interface
  search: [C(11, 11, 7), P("M21 21l-4.3-4.3")],
  help: [C(12, 12, 9), P("M9.5 9.2a2.6 2.6 0 0 1 5 1c0 1.8-2.5 2.3-2.5 3.8"), C(12, 17.2, 0.6)],
  sparkle: [P("M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"), P("M19 17l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z")],
  "arrow-left": [P("M19 12H5"), P("M11 6l-6 6 6 6")],
  "arrow-right": [P("M5 12h14"), P("M13 6l6 6-6 6")],
  "arrow-up": [P("M12 19V5"), P("M6 11l6-6 6 6")],
  "arrow-down": [P("M12 5v14"), P("M6 13l6 6 6-6")],
  "chevron-down": [P("M6 9l6 6 6-6")],
  "chevron-right": [P("M9 6l6 6-6 6")],
  check: [P("M5 12.5l4.5 4.5L19 7.5")],
  "check-circle": [C(12, 12, 9), P("M8 12.5l2.7 2.7L16 10")],
  "alert-circle": [C(12, 12, 9), P("M12 7.5v5.5"), C(12, 16.5, 0.6)],
  "x-circle": [C(12, 12, 9), P("M9 9l6 6"), P("M15 9l-6 6")],
  "minus-circle": [C(12, 12, 9), P("M8 12h8")],
  alert: [P("M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"), P("M12 9v4"), C(12, 17, 0.6)],
  info: [C(12, 12, 9), P("M12 11v5.5"), C(12, 7.8, 0.6)],
  plus: [P("M12 5v14"), P("M5 12h14")],
  x: [P("M6 6l12 12"), P("M18 6L6 18")],
  sun: [C(12, 12, 4), P("M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4")],
  moon: [P("M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z")],
  approvals: [P("M9 11l3 3L22 4"), P("M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11")],
  chat: [P("M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z")],
  play: [C(12, 12, 9), P("M10 8.5l5.5 3.5-5.5 3.5z")],
  compass: [C(12, 12, 9), P("M15.5 8.5l-2 5-5 2 2-5z")],
  star: [P("M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z")],
  lightbulb: [P("M9 18h6"), P("M10 21h4"), P("M12 3a6 6 0 0 0-3.6 10.8c.6.5 1 1.2 1 2V16h5.2v-.2c0-.8.4-1.5 1-2A6 6 0 0 0 12 3z")],
  horse: [P("M4 20l2-6 4-2 2-5 3-2 2 2-1 2 4 3-1 2-3-1-2 3v4"), P("M8 20v-4")],
  calendar: [R(3, 5, 18, 16), P("M3 10h18"), P("M8 3v4"), P("M16 3v4")],
  money: [R(2, 6, 20, 12), C(12, 12, 3), P("M6 9v.01"), P("M18 15v.01")],
  target: [C(12, 12, 9), C(12, 12, 5), C(12, 12, 1.2)],
  bolt: [P("M13 2L4 14h7l-1 8 9-12h-7z")],
  refresh: [P("M20 11a8 8 0 0 0-14.5-4.5L3 9"), P("M3 4v5h5"), P("M4 13a8 8 0 0 0 14.5 4.5L21 15"), P("M21 20v-5h-5")],
  camera: [P("M3 8a2 2 0 0 1 2-2h2l2-2h6l2 2h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"), C(12, 13, 3.5)],
  mic: [R(9, 3, 6, 11, 3), P("M5 11a7 7 0 0 0 14 0"), P("M12 18v3"), P("M8 21h8")],
  download: [P("M12 3v12"), P("M7 10l5 5 5-5"), P("M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2")],
  filter: [P("M3 5h18l-7 8v6l-4 2v-8z")],
  clock: [C(12, 12, 9), P("M12 7v5l3 2")],
  pencil: [P("M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4z"), P("M14 6l3 3")],
  copy: [R(8, 8, 13, 13), P("M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3")],
  send: [P("M22 2L11 13"), P("M22 2l-7 20-4-9-9-4z")],
  eye: [P("M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"), C(12, 12, 3)],
  lock: [R(5, 11, 14, 10), P("M8 11V7a4 4 0 0 1 8 0v4")],
  tag: [P("M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9z"), C(8, 8, 1.5)],
  percent: [P("M19 5L5 19"), C(6.5, 6.5, 2.5), C(17.5, 17.5, 2.5)],
  more: [C(5, 12, 1), C(12, 12, 1), C(19, 12, 1)],
  minus: [P("M5 12h14")],
  sliders: [P("M4 6h10"), P("M18 6h2"), C(16, 6, 2), P("M4 12h4"), P("M12 12h8"), C(10, 12, 2), P("M4 18h12"), P("M20 18h0"), C(18, 18, 2)],
  flame: [P("M12 22c4 0 7-3 7-7 0-4-3-6-4-10-2 2-3 4-3 6-1-1-2-2-2-4-3 3-5 5-5 8 0 4 3 7 7 7z")],
  thermometer: [P("M14 14.8V4a2 2 0 0 0-4 0v10.8a4 4 0 1 0 4 0z"), P("M12 10v6")],
  droplet: [P("M12 3s6 6.4 6 11a6 6 0 0 1-12 0c0-4.6 6-11 6-11z")],
  file: [P("M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"), P("M14 3v6h6")],
  printer: [P("M6 9V3h12v6"), R(3, 9, 18, 8), P("M6 14h12v7H6z")],
  link: [P("M10 14a4 4 0 0 0 6 0l3-3a4 4 0 0 0-6-6l-1 1"), P("M14 10a4 4 0 0 0-6 0l-3 3a4 4 0 0 0 6 6l1-1")],
  hash: [P("M5 9h14"), P("M5 15h14"), P("M10 3L8 21"), P("M16 3l-2 18")],
  undo: [P("M9 14L4 9l5-5"), P("M4 9h11a5 5 0 0 1 0 10h-3")],
  grid: [R(3, 3, 7, 7, 1.5), R(14, 3, 7, 7, 1.5), R(3, 14, 7, 7, 1.5), R(14, 14, 7, 7, 1.5)],
  inbox: [P("M3 13l3-8h12l3 8"), P("M3 13v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6"), P("M3 13h5l1 3h6l1-3h5")],
  zap: [P("M13 2L4 14h7l-1 8 9-12h-7z")],
  "trend-down": [P("M3 7l6 6 4-4 8 8"), P("M15 17h6v-6")],
  wand: [P("M15 4V2"), P("M15 10V8"), P("M11 6h2"), P("M17 6h2"), P("M3 21l12-12")],
  volume: [P("M11 5L6 9H3v6h3l5 4z"), P("M15.5 8.5a5 5 0 0 1 0 7"), P("M18.5 5.5a9 9 0 0 1 0 13")],
  "volume-x": [P("M11 5L6 9H3v6h3l5 4z"), P("M16 9l5 6"), P("M21 9l-5 6")],
  "bar-chart": [P("M4 20h16"), R(5, 11, 3, 7, 1), R(10.5, 6, 3, 12, 1), R(16, 13, 3, 5, 1)],
  stop: [R(6, 6, 12, 12, 2)],
  // menu categories (Products in Menu)
  sandwich: [P("M3 10c0-3 4-6 9-6s9 3 9 6z"), P("M3 13h18"), P("M4 16h16l-1 3H5z")],
  leaf: [P("M5 19c0-8 5-14 15-15-1 10-7 15-15 15z"), P("M5 19l8-8")],
  cup: [P("M5 8h13l-1.5 12a1 1 0 0 1-1 1H7.5a1 1 0 0 1-1-1z"), P("M4 8h15"), P("M9 8l1-5h4")],
  bottle: [P("M10 2h4v4l2 3v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9l2-3z"), P("M8 13h8")],
  cake: [P("M4 21h16v-7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2z"), P("M4 16c2 1.5 4 1.5 6 0s4-1.5 6 0 4 1.5 4 0"), P("M12 12V8"), P("M12 5.5v.01")],
  fries: [P("M6 10l1.5 11h9L18 10z"), P("M8 10V4"), P("M11 10V3"), P("M14 10V4"), P("M17 10V6")],
};

export const INV_ICONS = Object.keys(ICONS);

export default {
  name: "InvIcon",
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: null },
    stroke: { type: [Number, String], default: 1.8 },
  },
  render() {
    const shapes = ICONS[this.name];
    if (!shapes) return null;
    const sz = this.size == null ? "1em" : typeof this.size === "number" ? this.size + "px" : this.size;
    return h(
      "svg",
      {
        class: "inv-icon",
        viewBox: "0 0 24 24",
        width: sz,
        height: sz,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": this.stroke,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true",
        focusable: "false",
      },
      shapes.map(([tag, attrs]) => h(tag, attrs)),
    );
  },
};
</script>
